module.exports = __webpack_public_path__ + "static/media/register-succes.44854f9a.png";